import type { SoundDef } from './SoundManager.js';

// Synth fallback sound definitions (used when VITE_AUDIO_SOURCE='synth'
// or file loading fails). Split out of sounds.ts alongside soundFileDefs.

// Synth fallback definitions (used when VITE_AUDIO_SOURCE='synth' or file loading fails).
export const synthDefs: Record<string, SoundDef> = {
  hit: { type: 'synth', oscillator: 'square', frequency: 200, duration: 0.15, gain: 0.3 },
  arrow_hit: { type: 'synth', oscillator: 'square', frequency: 300, duration: 0.1, gain: 0.2 },
  shoot_arrow: { type: 'synth', oscillator: 'sine', frequency: 600, duration: 0.08, gain: 0.15 },
  shield_block: { type: 'synth', oscillator: 'square', frequency: 160, duration: 0.12, gain: 0.2 },
  death: { type: 'synth', oscillator: 'sawtooth', frequency: 80, duration: 0.4, gain: 0.3 },
  move: { type: 'synth', oscillator: 'sine', frequency: 400, duration: 0.1, gain: 0.15 },
  garrison: { type: 'synth', oscillator: 'sine', frequency: 300, duration: 0.2, gain: 0.2 },
  deploy: { type: 'synth', oscillator: 'sine', frequency: 500, duration: 0.15, gain: 0.2 },
  level_up: { type: 'synth', oscillator: 'sine', frequency: 600, duration: 0.4, gain: 0.25 },
  upgrade: { type: 'synth', oscillator: 'sine', frequency: 700, duration: 0.25, gain: 0.25 },
  city_damaged: { type: 'synth', oscillator: 'square', frequency: 150, duration: 0.3, gain: 0.3 },
  captured: { type: 'synth', oscillator: 'sawtooth', frequency: 100, duration: 0.6, gain: 0.4 },
  build_done: { type: 'synth', oscillator: 'sine', frequency: 800, duration: 0.3, gain: 0.25 },
  training_complete: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 500,
    duration: 0.25,
    gain: 0.2,
  },
  button_click: { type: 'synth', oscillator: 'sine', frequency: 800, duration: 0.05, gain: 0.1 },
  button_hover: { type: 'synth', oscillator: 'sine', frequency: 1000, duration: 0.04, gain: 0.06 },
  panel_open: { type: 'synth', oscillator: 'sine', frequency: 550, duration: 0.12, gain: 0.12 },
  panel_close: { type: 'synth', oscillator: 'sine', frequency: 450, duration: 0.12, gain: 0.12 },
  notification: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 700,
    duration: 0.15,
    gain: 0.15,
  },
  error: { type: 'synth', oscillator: 'square', frequency: 200, duration: 0.3, gain: 0.2 },
  doctrine_spend: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 600,
    duration: 0.2,
    gain: 0.2,
  },
  match_start: { type: 'synth', oscillator: 'triangle', frequency: 440, duration: 0.5, gain: 0.3 },
  achievement: { type: 'synth', oscillator: 'sine', frequency: 700, duration: 0.35, gain: 0.25 },
  discover_magic: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 900,
    duration: 0.3,
    gain: 0.2,
  },
  discover_treasure: {
    type: 'synth',
    oscillator: 'sine',
    frequency: 660,
    duration: 0.3,
    gain: 0.2,
  },
  fanfare: { type: 'synth', oscillator: 'sine', frequency: 523, duration: 0.8, gain: 0.3 },
  // Champion roar sting (cinematic legend.summoned; Firestorm cast).
  roar: { type: 'synth', oscillator: 'sawtooth', frequency: 70, duration: 1.2, gain: 0.35 },
  trumpets: { type: 'synth', oscillator: 'sawtooth', frequency: 440, duration: 0.5, gain: 0.25 },
  spell_healing_light: {
    type: 'synth',
    oscillator: 'sine',
    frequency: 880,
    duration: 0.6,
    gain: 0.3,
  },
  spell_teleport: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 1200,
    duration: 0.4,
    gain: 0.3,
  },
  spell_divine_shield: {
    type: 'synth',
    oscillator: 'sine',
    frequency: 500,
    duration: 0.5,
    gain: 0.3,
  },
  spell_summon_skeleton: {
    type: 'synth',
    oscillator: 'sawtooth',
    frequency: 100,
    duration: 0.7,
    gain: 0.4,
  },
  spell_lich_drain: {
    type: 'synth',
    oscillator: 'square',
    frequency: 200,
    duration: 0.5,
    gain: 0.35,
  },
  faith_sacrifice: {
    type: 'synth',
    oscillator: 'sawtooth',
    frequency: 80,
    duration: 0.8,
    gain: 0.4,
  },
  faith_crisis: { type: 'synth', oscillator: 'square', frequency: 150, duration: 1.2, gain: 0.4 },
  sanctified_pulse: { type: 'synth', oscillator: 'sine', frequency: 660, duration: 0.3, gain: 0.2 },
  assassin_success: {
    type: 'synth',
    oscillator: 'square',
    frequency: 250,
    duration: 0.2,
    gain: 0.3,
  },
  assassin_failure: {
    type: 'synth',
    oscillator: 'sine',
    frequency: 180,
    duration: 0.3,
    gain: 0.25,
  },
  sabotage_planted: {
    type: 'synth',
    oscillator: 'triangle',
    frequency: 350,
    duration: 0.25,
    gain: 0.25,
  },
  propaganda: { type: 'synth', oscillator: 'triangle', frequency: 440, duration: 0.4, gain: 0.25 },
  intel_gathered: { type: 'synth', oscillator: 'sine', frequency: 900, duration: 0.15, gain: 0.2 },
  convoy_departed: { type: 'synth', oscillator: 'sine', frequency: 300, duration: 0.2, gain: 0.25 },
  convoy_arrived: { type: 'synth', oscillator: 'sine', frequency: 500, duration: 0.3, gain: 0.3 },
  convoy_intercepted: {
    type: 'synth',
    oscillator: 'square',
    frequency: 220,
    duration: 0.4,
    gain: 0.35,
  },
};
